import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { ReportCardComponentProps } from '../schema-types';
import { filterDOMProps } from '../utils/prop-normalizer';

interface LabelData {
  text: string;
  backgroundColor?: string;
  textColor?: string;
  borderRadius?: number;
  padding?: number;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2';
  fontWeight?: 'normal' | 'bold' | 'bolder' | 'lighter' | number;
  textAlign?: 'left' | 'center' | 'right';
  minWidth?: string;
  margin?: number;
}

export const LabelComponent: React.FC<ReportCardComponentProps> = ({
  data,
  baseData: _baseData,
  player: _player,
  playerAssessment: _playerAssessment,
  reportCardLevel: _reportCardLevel,
  context: _context,
  organizationLogo: _organizationLogo,
  organizationLogoHeight: _organizationLogoHeight,
  ...props
}) => {
  const {
    text,
    backgroundColor = '#8bc34a',
    textColor = 'white',
    borderRadius = 8,
    padding = 1,
    variant = 'subtitle1',
    fontWeight = 'bold',
    textAlign = 'center',
    minWidth = '200px',
    margin = 2
  }: LabelData = data || {};

  return (
    <Box
      mb={margin}
      p={padding}
      style={{
        backgroundColor,
        borderRadius: `${borderRadius}px ${borderRadius}px 0 0`,
        display: 'inline-block',
        minWidth
      }}
      {...filterDOMProps(props)}
    >
      <Typography
        variant={variant}
        style={{
          color: textColor,
          fontWeight,
          textAlign
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};
